import Immutable from 'immutable';
import { NODE_TYPE } from './constants';
/**
 * Performs breadth first tree traversal of the assemblage node tree
 * Use tactical side effects in the callback function to do things with nodes
 * @param node root node the walking should begin from
 * @param {function} callback Fires on each node in the tree,
 *                   returning true from callback will abort traversal
 **/
export const treeWalker = (
  node,
  callback,
  { maxDepth = Infinity, currentDepth = 0 } = {}
) => {
  if (!node) {
    return;
  }
  if (callback(node, currentDepth)) {
    return;
  }
  const children = node.get('children');
  if (!children) {
    return;
  }
  if (maxDepth > 0 && children.size) {
    for (let i = 0; i < children.size; i += 1) {
      treeWalker(children.get(i), callback, {
        maxDepth: maxDepth - 1,
        currentDepth: currentDepth + 1,
      });
    }
  }
};

export const findLeafNodes = (node) => {
  const children = node.get('children', Immutable.List());
  if (children.size === 0) {
    return Immutable.List([node]);
  }
  const flatMapOfChildren = children.flatMap(findLeafNodes);
  return Immutable.List().concat(flatMapOfChildren);
};

export const findChildNodesByType = (node, nodeType) => {
  let nodes = Immutable.List();
  treeWalker(node, (currentNode) => {
    if (currentNode.get('node_type') === nodeType) {
      nodes = nodes.push(currentNode);
    }
  });
  return nodes;
};

export const findSectionNode = (assemblage, sectionId, topicsOnly = false) => {
  let sectionNode = null;
  const TOPIC_NODE_DEPTH = 1;
  treeWalker(assemblage.get('node'), (node, currentDepth) => {
    if (
      node.get('node_type') === NODE_TYPE.SECTION &&
      node.get('value_id') === sectionId &&
      (!topicsOnly || currentDepth === TOPIC_NODE_DEPTH)
    ) {
      sectionNode = node;
      return true;
    }
  });
  return sectionNode;
};

export const findTopicNodes = (assemblage) => {
  let topicNodes = Immutable.List();
  const TOPIC_NODE_DEPTH = 1;

  treeWalker(assemblage.get('node'), (currentNode, currentDepth) => {
    if (
      currentNode.get('node_type') === NODE_TYPE.SECTION &&
      currentDepth === TOPIC_NODE_DEPTH
    ) {
      topicNodes = topicNodes.push(currentNode);
    }
  });

  return topicNodes;
};
